export interface IOfferWidgetStoreState {
  isLoading: boolean;
  data: IOfferWidgetData;
}

export interface IOfferWidgetData {
  data: Array<{title: string; index: number; promo_list: Array<IOfferWidgetPromoItem>}>;
  success: boolean;
}

export interface IOfferWidgetPromoItem {
  promo: string;
  is_valid: boolean;
  offer_title: string;
  offer_bg_color: string;
  offer_font_color: string;
  logo_url: string;
  sub_heading1: string;
  sub_heading2: string;
  pcct: string;
  pcct_font_color: string;
  pcct_bg_color: string;
}

export const TOGGLE_LOADING_OFFER_WIDGET = 'TOGGLE_LOADING_OFFER_WIDGET';
export const UPDATE_OFFER_WIDGET = 'UPDATE_OFFER_WIDGET';
export const RESET_OFFER_WIDGET = 'RESET_OFFER_WIDGET';

export interface IToggleLoadingOfferWidget {
  type: typeof TOGGLE_LOADING_OFFER_WIDGET;
  actionData: IOfferWidgetStoreState['isLoading'];
}

export interface IUpdateOfferWidgetData {
  type: typeof UPDATE_OFFER_WIDGET;
  actionData: IOfferWidgetStoreState['data'];
}

export interface IResetOfferWidgetData {
  type: typeof RESET_OFFER_WIDGET;
}

export type OffeWidgetActionTypes =
  | IToggleLoadingOfferWidget
  | IUpdateOfferWidgetData
  | IResetOfferWidgetData;
